import { TextField } from '@globalmed/atlas-ui';
import { useState } from 'react';
import { TFormBuilderMultilineInputField } from '@/types';
import { MULTILINE_INPUT_MAX_LENGTH } from '@/constants';

type TProps = {
  field: TFormBuilderMultilineInputField;
};

/**
 * Preview component for multiline input field in form builder
 * @param props - Component props
 * @param props.field - Multiline input field data to preview
 * @returns Form builder multiline input preview component
 */
export const FormBuilderPreviewMultilineInput = ({ field }: TProps) => {
  const [value, setValue] = useState('');
  return (
    <TextField
      labelProps={{ label: field.label, required: field.required }}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={field.placeholder}
      sx={{ maxWidth: '343px', width: '100%' }}
      maxLength={MULTILINE_INPUT_MAX_LENGTH}
    />
  );
};
